module.exports = __webpack_public_path__ + "img/illust-404@2x.744b19d.png";